var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0002 1.83325C5.94016 1.83325 1.8335 5.93992 1.8335 10.9999C1.8335 16.0599 5.94016 20.1666 11.0002 20.1666C16.0602 20.1666 20.1668 16.0599 20.1668 10.9999C20.1668 5.93992 16.0602 1.83325 11.0002 1.83325ZM11.9168 15.5833H10.0835V13.7499H11.9168V15.5833ZM11.9168 11.9166H10.0835V6.41658H11.9168V11.9166Z",
    fill: "#DF271B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error-red.bd4dd595d56e0929711eb39e8d3aa31f.svg";
export { ForwardRef as ReactComponent };